/**
 * Runtime feature flags. Defaults are OFF so production stays on the legacy path
 * until a later phase explicitly enables async jobs (P4+).
 */
function envFlagOn(value: string | undefined): boolean {
  if (!value) return false;
  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

/** Hybrid async pipeline (SQS / jobs / Realtime). P0: read-only; dual-path is P4. */
export function isAsyncJobsEnabled(): boolean {
  return envFlagOn(process.env.REACT_APP_USE_ASYNC_JOBS);
}

/** Flip to true to restore Marketplace nav, route, tag publish, and purchase requests. */
export const MARKETPLACE_ENABLED = false;
